module.exports = __webpack_public_path__ + "img/01.c1ad9310.png";